import { observable, action, computed, toJS, runInAction } from "mobx";
import localStorage from "mobx-localstorage";
import moment from "moment";

const showClosedProjectsForMaoLocalStorageKey = "show-closed-projects-for-mao";

const IS_BIRD_APP = process.env.REACT_APP_ENV === "bird";

export default class MaintenanceAgencyStore {

  constructor(http, exporter) {
    this.http = http;
    this.exporter = exporter;
  }

  @observable
  ob_fetched_po_ma_data = {
    maintenanceAgencies: []
  };

  @observable selectedProjectTid = null;

  @observable
  obj_selected_project = {
    framework: "",
    frameworks: "",
    maintenanceAgency: {},
    maintenanceAgencyOwners: [],
    project: {},
    projectMembers: [],
    projectOwners: [],
    masterBranch: {},
  };

  @observable arr_all_frameworks = [];

  @observable arr_all_scheduled_jobs = [];

  @observable showScheduledPromotionJobsModal = false;

  @observable
  conf_updateFinalDate = {
    actionType: "UpdateOrchestration",
    orchestration: {
      tid: null,
      mid: null,
      name: null,
      description: null,
      projectType: null,
      isNonFrameworkType: null,
      status: null,
      creationDate: null,
      finalizationDate: null,
      type: null,
      framework: null,
      frameworks: null,
      frameworkFrom: null,
    }
  };

  @observable showClosedProjects = localStorage.getItem(showClosedProjectsForMaoLocalStorageKey) !== undefined
    ? localStorage.getItem(showClosedProjectsForMaoLocalStorageKey)
    : false;

  @observable
  schedulerDateTime = null;

  @observable
  selectedClosedProjects = [];

  @observable
  shouldCloseProjectOnPromote = true;

  @action
  mao_activate_maoStore = async () => {
    await this.helper_fetch_all_projects();
    await this.helper_fetch_all_frameworks();
  };

  @action("fetch all frameworks not used now maybe later")
  helper_fetch_all_frameworks = () => {
    if(IS_BIRD_APP) return;
    
    try {
      this.http.service_fetch_frameworks().then(
        action(res => {
          this.arr_all_frameworks = res.results;
        })
      );
    } catch (error) {
      console.error(error.message);
    }
  };

  @action("Promote Final Release Content to Production")
  action_promote_content_toPoductionMAO = projectData => {
    if(IS_BIRD_APP) return;
    
    const { project: { tid, projectType } } = projectData;
    
    // check project type
    if(projectType !== 'FRAMEWORK' && projectType !== 'MAPPING'){
      alert('Project type ' + projectType + ' not supported yet');
      return;
    }
    const formatedDate = this.schedulerDateTime &&  moment(this.schedulerDateTime).format("DD.MM.yyyy HH:mm:ss");
    const ob_confi_releaseToProduction = {
      actionType: "PromoteProject",
      pid: tid,
      shouldCloseProjectOnPromote: this.shouldCloseProjectOnPromote,
      date: formatedDate,
    };
    this.setSchedulerDateTime(null);
    runInAction(() => {
      this.http.func_sendGeneralMessage(ob_confi_releaseToProduction);
    });
  };

  doesMaContainProject = (maintenanceAgency, projectTid) => {
    for(let i = 0; i < maintenanceAgency.projects.length; i++) {
      if(maintenanceAgency.projects[i].project.tid === projectTid) {
        return true;
      }
    }
    return false;
  }

  @action
  action_selectProjectView = (selectedProjectTid) => {
    this.selectedProjectTid = selectedProjectTid;
    for(let i = 0; i < this.ob_fetched_po_ma_data.maintenanceAgencies.length; i++) {
      for(let j = 0; j < this.ob_fetched_po_ma_data.maintenanceAgencies[i].projects.length; j++) {
        if(this.ob_fetched_po_ma_data.maintenanceAgencies[i].projects[j].project.tid === selectedProjectTid) {
          this.obj_selected_project = this.ob_fetched_po_ma_data.maintenanceAgencies[i].projects[j];
          break;
        }
      }
    }

    this.ob_fetched_po_ma_data = {
      maintenanceAgencies: this.ob_fetched_po_ma_data.maintenanceAgencies.map(
        (ma, maIndex) => {
          if (this.doesMaContainProject(ma, selectedProjectTid)) {
            return {
              ...ma,
              visibility: true,
              projects: ma.projects.map((project, projectIndex) => {
                return {
                  ...project,
                  visibility: project.project.tid === selectedProjectTid
                };
              })
            };
          } else {
            return {
              ...ma,
              visibility: false
            };
          }
        }
      )
    };
  };

  @action
  mao_action_add_da = da => {
    if(IS_BIRD_APP) return;
    
    const da_aid = da;

    const { project: { tid } } = this.obj_selected_project;

    const ob_add_da_config = {
      actionType: "AddDictionaryAdministrator",
      pid: tid,
      aid: da_aid
    };

    runInAction(() => {
      this.http.func_sendGeneralMessage(ob_add_da_config);
    });
  };

  @action
  helper_fetch_all_projects = () => {
    if(IS_BIRD_APP) return;

    this.http.service_fetch_ALLMA().then(
      action(obj_mao_dataModel => {
        try {
          this.ob_fetched_po_ma_data = {
            maintenanceAgencies: obj_mao_dataModel.maintenanceAgencies.map(
              (ma, maIndex) => {
                return {
                  ...ma,
                  visibility: this.doesMaContainProject(ma, this.selectedProjectTid),
                  projects: ma.projects.map((project, projectIndex) => {
                    return {
                      ...project,
                      visibility: project.project.tid === this.selectedProjectTid
                    };
                  })
                };
              }
            )
          };
          this.action_selectProjectView(this.selectedProjectTid);
        } catch (error) {
          console.error(error.message);
          this.ob_fetched_po_ma_data.maintenanceAgencies = [];
        }
      })
    );

    return this.ob_fetched_po_ma_data;
  };

  @action("change finalization date in select project")
  action_change_finalizationDateMAO = (e_selected_date, selected_project) => {
    if(IS_BIRD_APP) return;
    
    const isoDate = e_selected_date.toISOString().split("T")[0];
    const new_finalizationDate = moment(isoDate).format("YYYY-MM-DD");
    const {
      tid,
      mid,
      name,
      description,
      projectType,
      isNonFrameworkType,
      status,
      creationDate,
      type,
      isFastTrack,
    } = selected_project.project;

    this.conf_updateFinalDate = {
      actionType: "UpdateOrchestration",
      orchestration: {
        tid: tid,
        mid: mid,
        name: name,
        description: description,
        projectType: projectType,
        isNonFrameworkType: isNonFrameworkType,
        status: status,
        creationDate: creationDate,
        finalizationDate: new_finalizationDate,
        type: type,
        // framework is framework's tid
        framework: selected_project.framework ? selected_project.framework.tid : null,
        frameworks: selected_project.frameworks ? selected_project.frameworks.map(framework => framework.tid).join(", ") : null,
        isFastTrack: isFastTrack,
      }
    };

    runInAction(() => {
      this.http.func_sendGeneralMessage(this.conf_updateFinalDate, response => {
        this.o_alert_data = response;
      });
    });
  };

  @action
  func_sendRequest = (jsonToSend, callback) => {
    if(IS_BIRD_APP) return;
    
    runInAction(() => {
      this.http.func_sendGeneralMessage(jsonToSend, response => {
        this.o_alert_data = response;
        if (response && response.resultType && response.resultType === "SUCCESS" && callback) {
          callback();
        }
      });
    });
  };

  @action
  reopenSelectedProject = () => {
    if(IS_BIRD_APP) return;
    
    const { tid } = this.obj_selected_project.project;
    const json = {
      actionType: "ReopenProject",
      pid: tid
    };
    this.http.func_sendGeneralMessage(json);
  }
  
  @action
  closeSelectedProject = () => {
    if(IS_BIRD_APP) return;
    
    const { tid } = this.obj_selected_project.project;
    const json = {
      actionType: "CloseProject",
      pid: tid
    };
    this.http.func_sendGeneralMessage(json);
  }

  @action
  toggleShowClosedProjectsForMao = () => {
    this.showClosedProjects = !this.showClosedProjects;
    localStorage.setItem(showClosedProjectsForMaoLocalStorageKey, this.showClosedProjects);
  }

  exportChangesInFrameworkInProduction = () => {
    if(IS_BIRD_APP) return;
    
    this.exporter.exportLatestProductionChangelog(this.obj_selected_project.frameworks);
  }

  @action
  setSchedulerDateTime = (date) => {
    if (date !== null) {
      const roundDate = this.roundDateHoursMinutes(date);
      this.schedulerDateTime = roundDate;
    }
  }

  @action
  fetchAllScheduledJobs = () => {
    if(IS_BIRD_APP) return;
    
    try {
      this.http.fetchScheduledJobs().then(
        action(res => {
          this.arr_all_scheduled_jobs = res;
        })
      );
    } catch (error) {
      console.error(error.message);
    }
  }

  @action
  updateScheduledJobs = (projectTid) => {
    if(IS_BIRD_APP) return;
    
    try {
      const params = {
        projectTid
      }
      this.http.updateScheduledJobs(params).then(
        action(res => {
          this.arr_all_scheduled_jobs = res;
        })
      );
    } catch (error) {
      console.error(error.message);
    }
  }

  @action
  toggleScheduledJobsModalVisibility = () => {
    if (!this.showScheduledPromotionJobsModal) {
      this.fetchAllScheduledJobs();
    }
    this.showScheduledPromotionJobsModal = !this.showScheduledPromotionJobsModal;
  }

  isScheduledPromotionJobsModalVisible = () => {
    return this.showScheduledPromotionJobsModal;
  }

  @action
  toggleSelectionForClosedProjects = (key) => {
    const index = this.selectedClosedProjects.indexOf(key);
    if (index !== -1) {
      this.selectedClosedProjects.splice(index, 1);
    } else {
      this.selectedClosedProjects.push(key);
    }
  }

  @action
  removeClosedSelectedProject = () => {
    if(IS_BIRD_APP) return;
    
    const json = {
      actionType: "DisableClosedProjects",
      pids: this.selectedClosedProjects,
      pid: this.selectedClosedProjects
    };
    this.selectedClosedProjects = [];
    this.http.func_sendGeneralMessage(json, response => {
      this.o_alert_data = response;
      if (response && response.resultType && response.resultType === "SUCCESS") {
        this.helper_fetch_all_projects();
      }
    });
  }

  @computed
  get getAllScheduledJobs() {
    return this.arr_all_scheduled_jobs;
  }
  
  @computed
  get getSchedulerDateTime() {
    return this.schedulerDateTime;
  }

  @computed
  get getShowClosedProjectsForMao() {
    return this.showClosedProjects;
  }

  @computed
  get computed_dataModel_for_menu() {
    return this.ob_fetched_po_ma_data.maintenanceAgencies;
  }

  @computed
  get get_obj_selected_project() {
    return this.obj_selected_project;
  }
  
  @computed
  get get_obj_maintenance_agencies() {
    return this.ob_fetched_po_ma_data.maintenanceAgencies;
  }

  @computed
  get get_arr_all_projects() {
    if (this.ob_fetched_po_ma_data.maintenanceAgenciescle) {
      return this.ob_fetched_po_ma_data.maintenanceAgencies.map(
        (ob_ma, maIndex) => {
          return toJS(ob_ma.projects);
        }
      );
    } else {
      return [];
    }
  }

  @computed
  get computed_arr_all_frameworks() {
    return this.arr_all_frameworks;
  }

  @computed
  get getSelectedClosedProjects() {
    return this.selectedClosedProjects;
  }

  checkDatesEquality = (date1, date2) => {
    return date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate() &&
      date1.getHours() === date2.getHours();
  }

  roundDateHoursMinutes = (date) => {
    if (this.checkDatesEquality(date, new Date())) {
      date.setHours(date.getHours() + 1);
    } else {
      date.setHours(date.getHours() + Math.round(date.getMinutes()/60));
    }
    date.setMinutes(0, 0, 0);

    return date;
  }

  toggleShouldCloseProjectOnPromote = () => {
    this.shouldCloseProjectOnPromote = !this.shouldCloseProjectOnPromote;
  }
}